import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Column, Row } from '@lux/components';

import PhoneCard from '../PhoneCard';

const StyledColumn = styled(props => <Column {...props} />)`
  display: flex;
  padding: 0;

  :nth-child(odd) {
    ${p => p.theme.media.sm`
      padding-right: ${p.theme.spacing(0.5)};
      padding-bottom: ${p.theme.spacing(1)};
    `};

    ${p => p.theme.media.md`
      padding: ${p.theme.spacing(1)};
    `};
  }

  :nth-child(even) {
    ${p => p.theme.media.sm`
      padding-left: ${p.theme.spacing(0.5)};
      padding-bottom: ${p.theme.spacing(1)};
    `};

    ${p => p.theme.media.md`
      padding: ${p.theme.spacing(1)};
    `};
  }
`;

const StyledRow = styled(props => <Row {...props} />)`
  margin: 0;
`;

const PhonesList = ({ selectedPlan, phones, onCardClick = () => {} }) => {
  return (
    <StyledRow data-testid="phones-list">
      {phones.map(phone => (
        <StyledColumn key={phone.id} sm={6} md={6} lg={4}>
          <div data-testid="phone-card" onClick={onCardClick}>
            <PhoneCard
              slug={phone.slug}
              heroImage={phone.heroImage}
              installmentPrice={phone.installmentPrice}
              monthlyTerm={phone.monthlyTerm}
              partialUpfrontAmount={phone.partialUpfrontAmount}
              title={phone.title}
              publicPrice={phone.publicPrice}
              ribbon={phone.ribbon}
              selectedPlan={selectedPlan}
            />
          </div>
        </StyledColumn>
      ))}
    </StyledRow>
  );
};

PhonesList.propTypes = {
  /** Sets the phone object */
  phones: PropTypes.arrayOf(
    PropTypes.shape({
      heroImage: PropTypes.object,
      installmentPrice: PropTypes.number,
      monthlyTerm: PropTypes.string,
      partialUpfrontAmount: PropTypes.number,
      title: PropTypes.string,
      publicPrice: PropTypes.number,
      slug: PropTypes.string,
      ribbon: PropTypes.string
    })
  ),
  onCardClick: PropTypes.func
};

export default PhonesList;
